import { Domicilio } from './Domicilio';

interface _FileDocument {
    code: string,
    file: string,
    binary: string,
    data: any  
}

class FileDocument implements _FileDocument {
    code: string
    file: string
    binary: string
    data: any  

    constructor() {
        this.code = '';
        this.file = '';
        this.binary = '';
        this.data = null;
    }
}

interface _CambioActividadEconomica {
    id: number | string
    has_alcohol: boolean
    numero_oficio_constancia_catastro: string
    folio_recibo_pago_donativo: string
    renovacion: number
    has_licencia_bebidas: boolean
    patente_propia: boolean
    folio_licencia_bebida_alcoholica: string
    giro_actividad_id: any
    actividades_secundarias: any[]
    numero_habitaciones: string
    tiene_uso_suelo: boolean
    tipo_propiedad_id: number | null
    tipo_proceso_id: number | null
    documentos: {
        scdd_constancia_rs: FileDocument
        scdd_saneamiento: FileDocument
        constancia_donativo: FileDocument
        recibo_pago_donativo: FileDocument
        licencia: FileDocument
        pago_licencia_bebidas: FileDocument
        licencia_comodato: FileDocument
        impuesto_hospedaje: FileDocument
        constancia_us_ca: FileDocument
    }
    predial: {
        //Documentos para predial
        titulo_escritura: FileDocument
        arrendamiento_contrato: FileDocument
        arrendamiento_identificacion: FileDocument
        arrendador_identificacion: FileDocument
        arrendamiento_testigos: FileDocument
        licencia_construccion: FileDocument
    }
    fotos: {
        frente: FileDocument,
        interior: FileDocument,
        wc: FileDocument,
        lateralIzquierdo: FileDocument,
        lateralDerecho: FileDocument
    }
}

export class CambioActividadEconomica implements _CambioActividadEconomica {
    id = ''
    numero_oficio_constancia_catastro = ''
    folio_recibo_pago_donativo = ''
    renovacion = 0
    has_alcohol = false
    has_licencia_bebidas = true
    patente_propia = true
    folio_licencia_bebida_alcoholica = ''
    giro_actividad_id = null
    actividades_secundarias = []
    numero_habitaciones = ''
    tiene_uso_suelo = false
    tipo_propiedad_id = null
    tipo_proceso_id = null
    documentos: any = {
        scdd_constancia_rs: new FileDocument(),
        scdd_saneamiento: new FileDocument(),
        constancia_donativo: new FileDocument(),
        recibo_pago_donativo: new FileDocument(),
        licencia: new FileDocument(),
        pago_licencia_bebidas: new FileDocument(),
        licencia_comodato: new FileDocument(),
        impuesto_hospedaje: new FileDocument(),
        constancia_us_ca: new FileDocument(),
    }
    predial: any = {
        //Documentos para predial
        titulo_escritura: new FileDocument(),
        arrendamiento_contrato: new FileDocument(),
        arrendamiento_identificacion: new FileDocument(),
        arrendador_identificacion: new FileDocument(),
        arrendamiento_testigos: new FileDocument(),
        licencia_construccion: new FileDocument()
    }
    fotos: any = {
        frente: new FileDocument(),
        interior: new FileDocument(),
        wc: new FileDocument(),
        lateralIzquierdo: new FileDocument(),
        lateralDerecho: new FileDocument()
    }
}